"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Button_1 = require("../Button");
var hooks_1 = require("../../hooks");
var Modal = function (_a) {
    var heading = _a.heading, show = _a.show, children = _a.children, closeButton = _a.closeButton, showClose = _a.showClose, closeFn = _a.closeFn, allowOverlayClose = _a.allowOverlayClose, style = _a.style, testId = _a.testId, fullscreen = _a.fullscreen;
    var setIsBodyScrollLocked = (0, hooks_1.useBodyScrollLock)().setIsBodyScrollLocked;
    React.useEffect(function () {
        setIsBodyScrollLocked(show);
        return function () { return setIsBodyScrollLocked(false); };
    }, [show]);
    var modalContentRef = React.useRef();
    var handleClickOutside = React.useCallback(function () {
        if (allowOverlayClose && closeFn && show) {
            setIsBodyScrollLocked(false);
            closeFn();
        }
    }, [allowOverlayClose, closeFn, show]);
    (0, hooks_1.useOnClickOutside)(modalContentRef, handleClickOutside);
    return (React.createElement("div", { className: "Modal ".concat(show ? 'Modal--open' : 'Modal--closed', " ").concat(fullscreen ? 'Modal--fullscreen' : ''), "data-testid": testId || 'modal' },
        React.createElement("div", { ref: modalContentRef, className: "Modal-content u-posRelative", style: __assign({}, (style || {})) },
            React.createElement("div", { className: "Modal-header u-flex u-flexJustifyBetween" },
                React.createElement("div", { className: "u-sizeFill" },
                    React.createElement("h2", { "data-testid": "modal-heading" }, heading)),
                showClose && (React.createElement(React.Fragment, null, closeButton || (React.createElement("div", { className: "Modal-close" },
                    React.createElement(Button_1.Button, { type: "link", onClick: function () { return closeFn === null || closeFn === void 0 ? void 0 : closeFn(); }, icon: "dismiss", mods: "u-colorNeutral9", otherProps: { 'data-testid': 'modal-heading-close-btn' } })))))),
            React.createElement("div", { className: "Modal-body", "data-testid": "modal-body" }, children))));
};
exports.default = Modal;
